export default __webpack_public_path__ + "static/media/Cart_default.dde9387b.svg";